import { useAuth } from '../../components/auth/AuthContext';
import AuthenticatedLandingBody from './components/AuthenticatedLandingBody';
import LandingHero from './components/LandingHero';
import './landingPage.css';

function LandingPage() {
  const { isAuthenticated, isInitialized, isLoggingOut } = useAuth();
  const baseTestId = 'landing-page';
  const keepAuthenticated = isAuthenticated || isLoggingOut;

  if (!isInitialized) {
    return null;
  }

  return (
    <div
      className={keepAuthenticated ? 'landing-page-shell landing-page-shell--authenticated' : 'landing-page-shell'}
      data-testid={baseTestId}>
      <LandingHero
        data-testid={`${baseTestId}-hero`}
        showCta={!keepAuthenticated}
      />
      {isAuthenticated && <AuthenticatedLandingBody data-testid={`${baseTestId}-body-authenticated`} />}
    </div>
  );
}

export default LandingPage;
